import React from 'react';

import { Box } from '@mui/material';

import type { SxProp } from 'src/types/mui';

import { Sidebar } from './components';

export const AuthLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <Box sx={containerStyles}>
      <Sidebar />

      <Box component="main" sx={contentStyles}>
        <Box sx={contentFlexChildStyles}>{children}</Box>
      </Box>
    </Box>
  );
};

const SIDEBAR_WIDTH_CSS_VAR_NAME = '--sidebar-width';

const containerStyles: SxProp = theme => ({
  [SIDEBAR_WIDTH_CSS_VAR_NAME]: '480px',

  display: 'grid',
  gridTemplateColumns: `var(${SIDEBAR_WIDTH_CSS_VAR_NAME}) auto`,
  gridTemplateRows: 'auto',
  height: '100%',

  [theme.breakpoints.down('md')]: {
    [SIDEBAR_WIDTH_CSS_VAR_NAME]: '300px',
  },
  [theme.breakpoints.down('sm')]: {
    display: 'block',
  },
});

const contentStyles: SxProp = theme => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'flex-start',

  width: '100%',
  overflowY: 'auto',

  p: 4,

  backgroundColor: 'slate.50',

  [theme.breakpoints.down('sm')]: {
    height: '100%',
  },
});

const contentFlexChildStyles: SxProp = {
  width: '100%',
  margin: 'auto 0',
};
